import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "canvas-wrap" }
const _hoisted_2 = {
  ref: "canvasRef",
  class: "canvas"
}
const _hoisted_3 = { class: "flex align-items-center justify-content-end gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "p-fluid",
    style: {"min-width":"600px","width":"60vw","max-width":"95vw"},
    header: "New Signature",
    modal: true,
    visible: _ctx.show,
    "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.show) = $event)),
    onShow: _ctx.onDialogShow
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Button, {
          label: "Clear",
          severity: "secondary",
          text: "",
          onClick: _ctx.clear
        }, null, 8, ["onClick"]),
        _createVNode(_component_Button, {
          label: "Undo",
          severity: "secondary",
          text: "",
          onClick: _ctx.undo
        }, null, 8, ["onClick"]),
        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "flex-1" }, null, -1)),
        _createVNode(_component_Button, {
          label: "Cancel",
          severity: "secondary",
          text: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.show = false))
        }),
        _createVNode(_component_Button, {
          label: "Update doc",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateSignature(false)))
        }),
        (_ctx.isInternalUser)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              label: "Save permanently",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateSignature(true)))
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("canvas", _hoisted_2, null, 512)
      ])
    ]),
    _: 1
  }, 8, ["visible", "onShow"]))
}